import { useQuery } from '@tanstack/react-query';
import { Card, Skeleton, Space } from 'antd';
import dayjs from 'dayjs';
import { IKeys } from 'models';
import { workService } from 'services';
import { userStore } from 'stores';
import { formatDiffs } from 'utils';

import { HistoryBlock } from './HistoryBlock';

interface WorkHistoryProps {
	workId: number;
}

export const WorkHistory = ({ workId }: WorkHistoryProps) => {
	const { data, isLoading } = useQuery({
		queryFn: () => workService.getHistory(workId),
		queryKey: [IKeys.HISTORY, workId]
	});

	return isLoading ? <Skeleton /> : (
		<Space vertical>
			{formatDiffs(data).map((revision) => {
				const revDate = dayjs(revision.date).format('MM/DD/YYYY HH:mm').toString();
				const authorName = userStore.getUser(Number(revision.author))?.name;
				const author = authorName === 'admin' ? 'Customer' : authorName;
				return (
					<Card 
						key={revision.id}
						size="small"
						title={`${revDate} by ${author}`}
					>
						<Space vertical style={{ display: 'flex' }}>
							{revision.added.length > 0 && (
								<HistoryBlock list={revision.added} type="success" title="Added:"/>
							)}
							{revision.updated.length > 0 && (
								<HistoryBlock list={revision.updated} type="info" title="Updated:"/>
							)}
							{revision.deleted.length > 0 && (
								<HistoryBlock list={revision.deleted} type="error" title="Deleted:"/>
							)}
						</Space>
					</Card>
				);
			})}
		</Space>
	);
};